import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { caption } from './caption';
import { media } from './media';
import { unknown } from './unknown';
export var mediaGroup = function mediaGroup(node) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = [];
  node.forEach(function (n) {
    switch (n.type.name) {
      case 'media':
        result.push(media(n, _objectSpread(_objectSpread({}, opts), {}, {
          parent: node
        })));
        break;
      case 'caption':
        result.push(caption(n, opts));
        break;
      default:
        result.push(unknown(n));
        break;
    }
  });
  return result.join('\n');
};